
const deployResquestDetails = () => $(".request-main-info").click(function() {
  return $(this).parent().find(".request-details").slideToggle(200);
});

document.addEventListener("turbo:load", function() {
  if (!App.currentPageIs("requests", "index")) { return; }

  return deployResquestDetails();
});
